import React, { useState, useEffect } from "react";
import "./Scramble.css";

import Solver2x2 from "./Solver2x2"

const Scrambo = require("scrambo"); // https://github.com/nickcolley/scrambo
const cube3x3 = new Scrambo().type("333"); //222,333,444,555,666,777,clock,minx,pyram,sq1,skewb

//console.log(cube3x3.get(1));


const Scramble = (props) => {
  // console.log("Scramble " + props.cts);

  const {cts, sendToApp, update } = props; // destructure props
  const [myScramble, setMyScramble] = useState();


  function randomState2x2(){
    return Solver2x2()
  }

  useEffect(() => {
    if (cts === false || update === true) {

      const x3 = cube3x3.get(1);
      const x2 = randomState2x2()  // random state scrambler

      if(props.puzzle === '2x2'){
        setMyScramble(x2);
        sendToApp(x2); //send scramble to App.js
      }else{
        setMyScramble(x3);
        sendToApp(x3); //send scramble to App.js
      }

    }
  }, [cts, sendToApp, update, props.puzzle]);


  return <div>{myScramble}</div>;
};
export default React.memo(Scramble);
